import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Button, Icon, Message, Loader, Dimmer } from 'semantic-ui-react';

const EditWalletAccountModal = ({ wallet, open, actions, onOpen, onClose, onSave }) => {
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);

	const defaultData = useMemo(() => {
		return {
			emailAddress: wallet.consumerEmail || ''
		};
	}, [wallet.consumerEmail]);

	const [data, setData] = useState(defaultData);

	const [isValid, setIsValid] = useState(data.emailAddress !== '');

	const _onSave = useCallback(async () => {
		setLoading(true);
		try {
			await actions.updatePaymentWallet(wallet.walletId, data.emailAddress);
		} catch {
			setError(true);
		}
		setLoading(false);
		if (onSave) onSave();
	}, [wallet, actions, data, onSave]);

	const _onOpen = useCallback(() => {
		setData({ ...defaultData });
		if (onOpen) onOpen();
	}, [defaultData, onOpen]);

	const onChange = useCallback(
		(name, value) => {
			setData({ ...data, [name]: value });
			setIsValid(value !== '');
		},
		[data]
	);

	return (
		<Modal
			size='tiny'
			onOpen={_onOpen}
			onClose={onClose}
			open={open}
			trigger={
				<span style={{ cursor: 'pointer' }}>
					<Icon name='edit' /> Edit Information
				</span>
			}>
			<Modal.Header>Edit Information</Modal.Header>
			<Modal.Content>
				{loading && (
					<Dimmer active inverted>
						<Loader active size='massive' />
					</Dimmer>
				)}
				{error && <Message error>Error saving Wallet information</Message>}
				<Form>
					<Form.Input label='Email Address' value={data.emailAddress || ''} onChange={(_, { value }) => onChange('emailAddress', value)} type="email" />
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>Cancel</Button>
				<Button primary onClick={_onSave} disabled={!isValid}>
					Save
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

EditWalletAccountModal.propTypes = {
	wallet: PropTypes.object.isRequired,
	open: PropTypes.bool.isRequired,
	payment: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	onSave: PropTypes.func
};

export default EditWalletAccountModal;
